import Vue from 'vue'
import App from './App.vue'
import router, { initDynamicRoutes } from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.scss'
import toastPlugin from './utils/toast'

Vue.config.productionTip = false
Vue.use(ElementUI)
// 统一 toast（2.5s 自动消失）与动效曲线工具，页面里用 this.$toast.success('已复制')。
Vue.use(toastPlugin)

async function bootstrap() {
  try {
    if (localStorage.getItem('token')) {
      await initDynamicRoutes()
    }
  } catch (error) {
    console.error('Failed to preload dynamic routes:', error)
  }

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()
